export const LAYERINFORMATION = 'LAYERINFORMATION'